//
// Enums
//
import { z } from "zod";
export const DocumentationItemHeaderAlignmentSchema = z.enum(["Left", "Center"]);
export const DocumentationItemHeaderImageScaleTypeSchema = z.enum([
    "AspectFill",
    "AspectFit",
]);
export const DocumentationItemHeaderAlignment = DocumentationItemHeaderAlignmentSchema.enum;
export const DocumentationItemHeaderImageScaleType = DocumentationItemHeaderImageScaleTypeSchema.enum;
